export interface ReferenceRevision {
  id: string;
  savedAt: number;
  body: string;
  anchors: { id: string; title: string }[];
  imported: boolean;
  actorId: string | null;
}

export function parseReferenceHistory(value: unknown): ReferenceRevision[] {
  if (!Array.isArray(value) || value.length > 20) throw new Error("Invalid Reference history");
  return value.map(item => {
    if (!item || typeof item.id !== "string" || !/^[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12}$/i.test(item.id) || !Number.isSafeInteger(item.savedAt) || item.savedAt < 0 || item.savedAt > 253402300799000 || typeof item.body !== "string" || new TextEncoder().encode(item.body).length > 65536 || !Array.isArray(item.anchors) || item.anchors.length > 200 || item.anchors.some((anchor: {id?: unknown; title?: unknown}) => !anchor || typeof anchor.id !== "string" || !anchor.id || new TextEncoder().encode(anchor.id).length > 100 || typeof anchor.title !== "string" || new TextEncoder().encode(anchor.title).length > 200)) throw new Error("Invalid Reference revision");
    return { id: item.id, savedAt: item.savedAt, body: item.body, anchors: item.anchors.map((anchor: {id: string;title: string}) => ({ id: anchor.id, title: anchor.title })), imported: !!item.imported, actorId: typeof item.actorId === "string" ? item.actorId : null };
  });
}
